import { IMPRIMIR_LOCAL_STORAGE_KEY } from "constants/keys";

export function resetPrintPage(pageKey: string) {
  localStorage.removeItem(IMPRIMIR_LOCAL_STORAGE_KEY);
  localStorage.removeItem(pageKey);
  setTimeout(() => window.close(), 2000)
}
